import { SellerRole } from '../../gql-operations/gql-generated';
import { getRoleTitleTextualEntity } from './getRoleTitleTextualEntity';
import { translateTextualEntity } from './i18n/translateTextualEntity';

export const translateRoleTitle = (role: SellerRole, variantId?: string) =>
    translateTextualEntity(getRoleTitleTextualEntity(role, variantId));
